// extracted by mini-css-extract-plugin
export default {"title-container":"Ct3Nt6","titleContainer":"Ct3Nt6","semi-bold":"UiL0_d","semiBold":"UiL0_d","back-button":"AbdXeP","backButton":"AbdXeP"};